import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import { LayoutDashboard, User , Files ,FolderClosed ,SquarePen , TriangleAlert } from "lucide-react";
import {
  BsList,
  BsPencilSquare,
 
  BsBoxArrowRight,

  BsFillPeopleFill,
} from "react-icons/bs";
import { FaChartPie, } from "react-icons/fa";
import "./Navigation Buttons.css";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserDataAPI } from "../../api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useStore } from "../utils/store";

export const NavigationButtons = ({ handleUpdatePersonalDetails, handleLogout, IsDashbaord = false }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current path

  const showEmploymentVerificationActiveInactive = useStore(
    (state) => state.showEmploymentVerification
  );


  const [userProfileData, setUserProfileData] = useState({});
  const [showEmploymentVerification, setShowEmploymentVerification] =
    useState(false);
  const [showCreateNewApplicationTab, setShowCreateNewApplicationTab] =
    useState(false);
  const [showIncompleteApplicationTabTab, setShowIncompleteApplicationTabTab] =
    useState(false);

  const [navigationTeamMember, setNavigationTeamMember] = useState(false);


  const handleMyTeam = () => {
    navigate("/user/my_team");
  }

  // Mapping paths to icons and labels
  const pathInfo = {
    "/user/dashboard": {
      icon: <LayoutDashboard size={20} />,
      label: "Dashboard",
      action: () => navigate("/user/dashboard"),
      status: "active",
    },
     "/user/incomplete_applications": {
    icon:<SquarePen size={20} />,
    label: "Incomplete Applications",
    action: () => navigate("/user/incomplete_applications"),
    status: "active",
  },
  "/user/submitted_applications": {
    icon: <Files size={20} />,
    label: "Submitted Applications",
    action: () => navigate("/user/submitted_applications"),
    status: "active",
  },
  "/user/employment_verification_pending": {
    icon: <TriangleAlert size={20} />,
    label: "Employment Verification Pending",
    action: () => navigate("/user/employment_verification_pending"),
    status: showEmploymentVerificationActiveInactive ? "active" : "inactive",
  },
  "/user/forms": {
    icon: <FolderClosed size={20} />,
    label: "Application Support Files",
    action: () => navigate("/user/forms"),
    status: "active",
  },
  };

  const defaultIcon = <BsList size={18} style={{ color: "#055837" }} />;
  const defaultLabel = "Menu";

  const currentPath = location.pathname;
  const { icon: currentIcon, label: currentLabel } = pathInfo[currentPath] || {
    icon: defaultIcon,
    label: defaultLabel,
  };

  const userID = localStorage.getItem("userId");


  const userName = localStorage.getItem("userName");




  const fetchUserData = async () => {
    try {
      const response = await getUserDataAPI(userID);

      if (
        response.data?.response &&
        response.data?.response?.response === true &&
        response.data?.response?.user_details
      ) {
        if (response.data?.response?._members === true) {
          setNavigationTeamMember(true);
        }
        setUserProfileData(response?.data?.response?.user_details);
      } else if (
        response.status === 200 &&
        response.data === "Missing JWT token"
      ) {
        fetchUserData(userID);
      } else {
        console.error(
          "Error fetching:",
          response.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    setShowEmploymentVerification(
      localStorage.getItem("showEmploymentVerification")
    );
    setShowCreateNewApplicationTab(
      localStorage.getItem("showCreateNewApplicationTab")
    );
    setShowIncompleteApplicationTabTab(
      localStorage.getItem("showIncompleteApplicationTabTab")
    );
  }, []);

  // Filter menu options based on the current path to avoid showing the same option
  const menuOptions = Object.keys(pathInfo).filter(
    (path) => path !== currentPath
  );

  return (
    <div className="header_border">
      {/* {IsDashbaord && (
        <hr class="mb-2 thick-hr" />
      )} */}
      
      <div>
        <Row className="mb-2">
          <Col
            className="d-flex justify-content-end align-items-center"
            style={{ marginRight: "25px", color: "#055837" }}
          >
       
  <Dropdown className="me-2">
  <Dropdown.Toggle
    variant=""
    id="dashboard-dropdown"
    className={`border-0 text-dark d-flex align-items-center ${currentPath !== "/user/dashboard" ? "" : 'dropdown-toggle-no-arrow noUnderlineHover'}`}
    style={{ color: "black", outline: "none", boxShadow: "none" }}
  >
    <div
      className="me-1 d-flex align-items-center"
      style={{ display: "inline-flex" }}
    >
      {currentIcon}
      <span
        style={{
          color: "black",
          verticalAlign: "middle",
          marginLeft: "8px",
        }}
      >
        {currentLabel}
      </span>
    </div>
  </Dropdown.Toggle>

  {/* Only show Dropdown.Menu if not on /user/dashboard */}
  {currentPath !== "/user/dashboard" && (
    <Dropdown.Menu>
      {menuOptions
      .filter((path) => pathInfo[path]?.status !== "inactive")
      .map((path) => (
        <Dropdown.Item
          key={path}
          onClick={pathInfo[path].action}
          className="d-flex align-items-center"
        >
          <span className="me-2 d-flex align-items-center">
            {pathInfo[path].icon}
          </span>
          <span>{pathInfo[path].label}</span>
        </Dropdown.Item>
      ))}

    </Dropdown.Menu>
  )}
</Dropdown>




            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="user-dropdown"
                className="border-0 text-dark d-flex align-items-center"
                style={{ color: "#055837", outline: "none", boxShadow: "none" }}
              >
                <User size={20} />
                <span
                  style={{
                    color: "black",
                    textDecoration: "none",
                    transition: "text-decoration 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  Welcome{" "}
                  <b style={{ textDecoration: "inherit" }}>
                    {/* {userProfileData?.name} */}
                    {userName}
                  </b>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleUpdatePersonalDetails}>
                  <BsPencilSquare className="me-2" /> My Profile
                </Dropdown.Item>
                {navigationTeamMember && (

                  <Dropdown.Item onClick={handleMyTeam}>
                    <BsFillPeopleFill className="me-2" /> My Team
                  </Dropdown.Item>

                )}
                <Dropdown.Item onClick={handleLogout}>
                  <BsBoxArrowRight className="me-2" /> Sign Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </div>
      {IsDashbaord && (
        <hr class="mb-2 thick-hr" />
      )}

    </div>

  );
};

export default NavigationButtons;